/**
 * @file SecurityRoleWizardStepper.js
 * @description Horizontal breadcrumb step indicator for the security role wizard.
 */
import React from 'react';
import styles from './security-roles.module.scss';

const SecurityRoleWizardStepper = ({ steps, activeStepIndex, onStepClick }) => (
    <div className={styles.stepperWrapper}>
        {steps.map((step, index) => {
            const isActive = index === activeStepIndex;
            const labelClass = isActive
                ? `${styles.stepLabel} ${styles.stepLabelActive}`
                : styles.stepLabel;

            return (
                <React.Fragment key={step}>
                    <span
                        className={labelClass}
                        onClick={() => !isActive && onStepClick(index)}
                    >
                        {step}
                    </span>
                    {index < steps.length - 1 && (
                        <span className={styles.stepSeparator}>›</span>
                    )}
                </React.Fragment>
            );
        })}
    </div>
);

export default SecurityRoleWizardStepper;
